import Consts from '../../consts/clientConsts'

export default {

    mapFromDto(feedDto) {
        let feedList = [];

        if (!feedDto && !feedDto.length)
            return feedList;

        feedDto.forEach((e) => {
            feedList.push(new FeedItem().mapFromDto(e));
        });

        return feedList;
    }
}

class FeedItem {
    Id = null;
    Name = null;
    CreatedDate = null;
    Status = null;
    Type = null;
    TemplateName = null;
    ImagePath = null;
    Color = null;

    mapFromDto(auditDto) {

        this.Id = auditDto.Id;
        this.Name = auditDto.Name;
        this.CreatedDate = this.setDateCreated(auditDto.CreatedDate);
        this.Status = Consts.AuditStatus.find(e => e.Id == auditDto.Status);
        this.Type = Consts.AuditType.find(e => e.Id == auditDto.Type);
        this.TemplateName = auditDto.TemplateName;
        
        this.ImagePath = this.setImagePath();
        this.Color = this.setStatusColor();

        return this;
    }

    setDateCreated(dateDto) {
        let date;
        let now = new Date();
        date = new Date(dateDto);

        if ((now.getDate() - date.getDate() == 0) && (now.getMonth() - date.getMonth() == 0)) {
            return "Сегодня";
        }
        else if ((now.getDate() - date.getDate() == 1) && (now.getMonth() - date.getMonth() == 0)) {
            return "Вчера";
        }
        else {
            return date.getDate().toString() + " " + Consts.months.find(e => e.Id == date.getMonth()).Text;
        }
    }

    setStatusColor() {
        let color;

        switch (this.Status.Id) {
            case (1):
                color = "ongoing"
                break;
            case (2):
                color = "completed"
                break;
            case (3):
                color = "sendend"
                break;
            case (4):
                color = "deleted"
                break;
        }

        return color;
    }

    setImagePath() {
        let path = "/img/lenta-";

        switch (this.Type.Id) {
            case (1):
                path += "audit-";
                break;
            case (2):
                path += "operative-";
                break;
            case (3):
                path += "inspector-";
                break;
        }

        path += this.setStatusColor();

        return path + ".png";
    }
}
